import { Component } from '@angular/core';
import { LanguageService, LoadingService } from '@hazmatsuite-next/ui';
import { Store } from '@ngrx/store';
import { Observable, Subject, debounceTime, filter, take } from 'rxjs';
import { EasyDgdDataState } from './store/easydgd-data.reducer';
import { selectInitialStepRoute, selectStepState } from './store/easydgd-data.selectors';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { setSelectedStep } from './store/easydgd-data.actions';
import { steps } from '@hazmatsuite-next/easydgd-lib';

@UntilDestroy()
@Component({
  selector: 'easydgd-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  isLoading$: Observable<boolean>;
  translationLoadingSubject = new Subject<void>();
  stepperItems$ = this.easyDgdStore.select(selectStepState);

  private currentRoute: ActivatedRoute | null = null;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private easyDgdStore: Store<{ easyDgdState: EasyDgdDataState }>,
    private loadingService: LoadingService,
    private languageService: LanguageService) {

    this.isLoading$ = this.loadingService.loadingStatus.pipe(debounceTime(200));

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.currentRoute = this.getDeepestChild(this.activatedRoute);
        if (this.currentRoute) {
          this.easyDgdStore.select(selectInitialStepRoute).pipe(
            take(1)
          ).subscribe(route => {
            this.navigateToRoute(route);
          })
        }
      });

    this.easyDgdStore.select(selectInitialStepRoute).pipe(
      untilDestroyed(this)
    ).subscribe(route => {
      this.navigateToRoute(route);
    });
  }

  private navigateToRoute(route: string | undefined) {
    if (route && this.currentRoute) {
      const currentPath = window.location.pathname;
      const path = `/easydgd/${route}`;
      const completePath = `/${this.languageService.getLanguage()}${path}`;
      if (completePath.includes(currentPath)) {
        this.router.navigate([route], { relativeTo: this.currentRoute });
      } else {
        this.router.navigate([route], { relativeTo: this.currentRoute });
      }
    }
  }

  selectStep(index: number): void {
    this.easyDgdStore.dispatch(setSelectedStep({ index }));
    const route = steps({})[index]?.relativeRoute;
    this.router.navigate([route], { relativeTo: this.currentRoute });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
